export function isAuthRoute(pathname: string) {
  return pathname.startsWith('/auth/');
}
